/**
 * en-GB messages added by Phase 3 task S36 (docs/PHASE-3-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 */
export const s36EnGB = {
    'kioskDevices.alert.problem.queue_stuck': 'Sign-ins have been waiting to be sent for {minutes} minutes ({queueLength} waiting, {deadLetters} refused)',
    'kioskDevices.alert.name.queue_stuck': 'Events not sending',
    'error.remote_site_no_kiosk': 'A remote site cannot have a kiosk.',
};
//# sourceMappingURL=s36.js.map